(function(window, document, $, undefined){
// jQuery(document).ready(function($) {

  if (!!Cookies.get('cookie-consent')) {
    // has cookie, do nothing
  } else {
    // no cookie, show cookie consent div
    $('#cookie-consent').css('visibility','visible');
    $('body').addClass('cookie-consent');
    // add padding to footer to allow for the div
    // $('footer').css('margin-bottom','100px');
  }


  // dismiss click handler
  $('#cookie-consent a[data-cookie-consent-dismiss]').click(function(e) {
    e.preventDefault();
    // set the cookie
    Cookies.set('cookie-consent', 'accepted');
    // fade out the div
    $('#cookie-consent').fadeOut(500,function(){
      // reset the padding of the footer back to normal
      $('#cookie-consent').css('visibility','hidden');
      // $('footer').css('margin-bottom','0');
      $('body').removeClass('cookie-consent');
      $(window).resize();
    });


    $('.site-footer').delay(200).animate({
      paddingBottom: 0},
      500, function() {
      /* stuff to do after animation is complete */
    });


  });
  
// });
})(window, document, jQuery);
